export enum TriggerType {
  DatePattern = 'DatePattern',
  LinkToOtherTask = 'LinkToOtherTask',
  TriggerByCondition = 'TriggerByCondition',
  Special = 'Special'
}
